/* eslint-disable max-len */
import {ACTION_BUTTON_Z_INDEX} from '../ActionButtons';

const otherPlayersCardHeight = 32;

const desktop = theme => {
  const {toVW} = theme;
  return {
    playerInfoBox: {
      width: 80,
      height: 26,
    },
    playerName: {
      fontSize: 11,
      lineHeight: '11px',
    },
    playerTopActionBottom: {
      extend: 'displayContainer',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& > div:first-child': {
        // Chip margin
      },
      '& $roleAndChipContainer': {
        // Chip margin
        zIndex: 4,
        marginTop: 10,
      },
    },
    cardsBackContainer: {
      bottom: '10%',
      right: '4px',
      '&.playersRHS': {
        left: 0,
        right: 'unset',
      },
      '&.omaha': {
        left: 36,
      },
      '&.omaha.playersRHS': {
        left: 21,
      },
    },
    playerHandForResultPhase: {
      // left: '50%',
      right: '4px',
      transformOrigin: 'bottom',
      // transform: 'translate(-50%, 0)',
      bottom: '27%',
      // top: 'unset',
      '&$omahaResultCardList': {
        right: '-75px',
      },
    },
    playerHandForResultPhaseRHS: {
      // left: '50%',
      bottom: '27%',
      // zIndex: 1,
      '&$omahaResultCardList': {
        left: -13,
      },
    },
    omahaResultCardList: {
      right: 'unset',
    },
    myPlayerHandForResultPhase: {
      '&$omahaResultCardList': {
        right: '-77px',
      },
    },
    myCardsContainer: {
      bottom: '31.5%',
      top: 'unset',
    },
    myWinningCards: {
      bottom: '29%',
    },
    blueLabel: {
      width: 90,
    },
    outcardsOnTable: {
      gridTemplateColumns: 'repeat(6, 1fr)',
    },
    leftWinPercentage: {
      right: 90,
    },
    rightWinPercentage: {
      left: 90,
    },
    bottomWinPercentage: {
      left: 85,
    },
    topWinPercentage: {
      left: 90,
      right: 'unset',
    },
    topWinPercentageAndResultIsShowing: {
      transform: 'translate(0%, 50%)',
    },
    playerTopLeftAllIn: {
      flexDirection: 'row-reverse',
    },
    playerTopRightAllIn: {
      flexDirection: 'row',
    },
    currentDecision: {
      minWidth: '50px',
      top: '44%',
      padding: '3px 6px',
    },
    myDecision: {
      top: '86.5%',
      left: '50%',
      transform: 'translate(-50%, 0%)',
    },
    myBestCombination: {
      right: 0,
      bottom: 0,
    },
    cardBack: {
      height: otherPlayersCardHeight,
    },
    cardBack_1: {
      marginLeft: -13,
      '&.omaha': {
        marginLeft: -30,
      },
    },
    cardBack_2: {
      '&.omaha': {
        marginLeft: -30,
      },
    },
    cardBack_3: {
      '&.omaha': {
        marginLeft: -30,
      },
    },
    bestCombinationBodyDesktop: {
      extend: 'bestCombinationBody',
      marginRight: '0px',
      background:
        'transparent url(/images-mobile/game-room/bestCombinationBodyDesktop.webp) no-repeat',
      paddingLeft: '0px',
      paddingRight: '10px',
    },
    bestCombinationTriangleDesktop: {
      extend: 'bestCombinationTriangle',
      background:
        'transparent url(/images-mobile/game-room/bestCombinationTriangleDesktop.webp) no-repeat',
    },
    combinationText: {
      transform: 'translateX(0px)',
    },
    currentDecisionAllin: {
      fontSize: 10,
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  const iconWidth = 45;
  const iconRatio = 0.65;
  const haloPadding = 2;
  const getPlayerHalo = (color: string) => ({
    padding: haloPadding,
    borderRadius: '50%',
    boxShadow: `${color} 0px 0px 15px`,
  });
  const chipsWrapperMinWidth = 35;

  return {
    // playerContainer: {
    //   display: 'flex',
    //   flexDirection: 'column',
    // },
    playerInfoContainer: {
      display: 'flex',
      flexDirection: 'column',
      // alignItems: 'center',
      position: 'relative',
      '&.isInActive': {
        alignItems: 'center',
      },
    },
    playerRHS: {
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
    },
    playerInfoBox: {
      position: 'relative',
      width: 80,
      height: 40,
      // TODO: bug
      zIndex: 3,
      marginTop: -20,
      // eslint-disable-next-line max-len
      background:
        'linear-gradient(349.13deg, #2C3238 5.84%, #303336 33.9%, #171717 61.97%, #4D5358 90.03%);',
      boxShadow: 'inset 0px 0px 5px rgba(255, 255, 255, 0.5)',
      borderRadius: 4,
      '&.isWinner': {
        // padding: haloPadding,
        boxShadow: `#FFD945 0px 0px 15px`,
      },
      '&.isMyself': {
        marginTop: `-20px`,
        width: '120px',
        // marginTop: `-20px`,
      },
    },
    playerAvatar: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: `${iconRatio * 100}%`,
      height: `${iconRatio * 100}%`,
      transform: 'translate(-50%, -50%)',
      '& img': {
        borderRadius: '50%',
        objectFit: 'cover',
        width: '100%',
        height: '100%',
      },
    },
    timer: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    playerIconContainer: {
      position: 'relative',
      width: 'fit-content',
      // maxWidth: 70,
      // maxWidth: 80,
      display: 'inline-block',
      padding: haloPadding,
      '&.isInAction': {
        ...getPlayerHalo('blue'),
      },
      '&.isWinner': getPlayerHalo('#FFD945'),
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },
    '@keyframes rotate': {
      '0%': {
        transform: 'translate(-50%, -50%) rotate(0deg)',
      },
      '100%': {
        transform: 'translate(-50%, -50%) rotate(360deg)',
      },
    },
    winnerLight: {
      width: 300,
      height: 300,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      animation: '$fadeIn 1s ease-in-out, $rotate 5s linear infinite',
      '&.hidden': {
        display: 'none',
      },
    },
    '@keyframes rotateAntiClockwise': {
      '0%': {
        transform: 'translate(-50%, -50%) rotate(0deg)',
        opacity: 0.5,
      },
      '100%': {
        transform: 'translate(-50%, -50%) rotate(-360deg)',
        opacity: 0.5,
      },
    },
    secondaryWinnerLight: {
      width: 300,
      height: 300,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      animation: '$fadeIn 1s ease-in-out, $rotateAntiClockwise 5s linear infinite',
      '&.hidden': {
        display: 'none',
      },
    },
    playerAvatarBorder: {
      fontSize: iconWidth,
    },
    tournamentRankText: {
      position: 'absolute',
      color: '#fff',
      fontWeight: '800',
      textShadow: '0 0 5px #33c4e8, 0 0 2px #33c4e8',
    },
    playerHandForResultPhase: {
      display: 'flex',
      position: 'absolute',
      right: '0%',
      bottom: '38%',
      zIndex: 1,
    },
    playerHandForResultPhaseRHS: {
      display: 'flex',
      position: 'absolute',
      left: '0%',
      bottom: '38%',
      zIndex: 1,
      '&$omahaResultCardList': {
        left: -13,
      },
    },
    myCardsContainer: {
      display: 'flex',
      position: 'absolute',
      bottom: '38%',
      right: 0,
    },
    myPlayerHandForResultPhase: {
      bottom: '38%',
    },
    cardOnResultPhase_0: {
      // transform: 'rotate(-10deg)',
      '&.omaha': {
        transform: 'rotate(-15deg)',
        transformOrigin: 'right',
      },
    },
    cardOnResultPhase_1: {
      // TODO otherwise there will be a gap
      marginLeft: -15,
      // transform: 'rotate(10deg)',
      '&.omaha': {
        transform: 'rotate(-5deg)',
        transformOrigin: 'right',
        marginLeft: 0,
        left: -22,
      },
    },
    cardOnResultPhase_2: {
      '&.omaha': {
        transform: 'rotate(5deg)',
        transformOrigin: 'left',
        right: 44,
      },
    },
    cardOnResultPhase_3: {
      '&.omaha': {
        transform: 'rotate(15deg)',
        transformOrigin: 'left',
        right: 66,
      },
    },
    '@keyframes enlarge': {
      from: {},
      to: {
        width: 57,
        height: 75,
      },
    },
    '@keyframes enlargeOmaha': {
      from: {},
      to: {
        width: 50,
        height: 68,
      },
    },
    enlargedCardAnimation: {
      '& > div > div': {
        animation: '$enlarge 0.5s ease-in forwards',
      },
    },
    enlargedCardAnimationOmaha: {
      '& > div > div': {
        animation: '$enlargeOmaha 0.5s ease-in forwards',
      },
    },
    '@keyframes otherPlayersCardsOnWinningPhase': {
      from: {
        // width:33.75,
        // height: 45,
      },
      to: {
        width: 42,
        height: 55,
      },
    },
    otherPlayersCardsOnWinningPhase: {
      '& > div > div': {
        animation: '$otherPlayersCardsOnWinningPhase 1s ease-in forwards',
      },
    },
    // otherPlayersCardsOnWinningPhase_0: {
    //   '&.omaha': {
    //     transform: 'rotate(-15deg)',
    //     transformOrigin: 'right',
    //     left: 22,
    //   },
    // },
    // otherPlayersCardsOnWinningPhase_1: {
    //   marginLeft: -15,
    //   '&.omaha': {
    //     transform: 'rotate(-5deg)',
    //     transformOrigin: 'right',
    //     marginLeft: 0,
    //     left: 7,
    //   },
    // },
    // otherPlayersCardsOnWinningPhase_2: {
    //   '&.omaha': {
    //     transform: 'rotate(5deg)',
    //     transformOrigin: 'left',
    //     right: 7,
    //   },
    // },
    // otherPlayersCardsOnWinningPhase_3: {
    //   '&.omaha': {
    //     transform: 'rotate(15deg)',
    //     transformOrigin: 'left',
    //     right: 22,
    //   },
    // },
    '@keyframes myCardOnWinningPhase': {
      from: {
        // width:33.75,
        // height: 45,
      },
      to: {
        width: 52,
        height: 75,
      },
    },

    myCardOnWinningPhase: {
      // bottom: '29%',
      // right: 0,
      '& > div > div': {
        animation: '$myCardOnWinningPhase 1s ease-in forwards',
      },
    },
    // myCardOnWinningPhase_0: {
    //   '&.omaha': {
    //     transform: 'rotate(-15deg)',
    //     transformOrigin: 'right',
    //     left: 22,
    //   },
    // },
    // myCardOnWinningPhase_1: {
    //   marginLeft: -15,
    //   '&.omaha': {
    //     transform: 'rotate(-5deg)',
    //     transformOrigin: 'right',
    //     marginLeft: 0,
    //     left: 7,
    //   },
    // },
    // myCardOnWinningPhase_2: {
    //   '&.omaha': {
    //     transform: 'rotate(5deg)',
    //     transformOrigin: 'left',
    //     right: 7,
    //   },
    // },
    // myCardOnWinningPhase_3: {
    //   '&.omaha': {
    //     transform: 'rotate(15deg)',
    //     transformOrigin: 'left',
    //     right: 22,
    //   },
    // },
    myCard_0: {
      // transform: 'rotate(-10deg)',
      '&.omaha': {
        transform: 'rotate(-15deg)',
        transformOrigin: 'right',
        left: 22,
      },
    },
    myCard_1: {
      // transform: 'rotate(10deg)',
      // TODO override by container
      marginLeft: -15,
      '&.omaha': {
        transform: 'rotate(-5deg)',
        transformOrigin: 'right',
        marginLeft: 0,
        left: 7,
      },
    },
    myCard_2: {
      '&.omaha': {
        transform: 'rotate(5deg)',
        transformOrigin: 'left',
        right: 7,
      },
    },
    myCard_3: {
      '&.omaha': {
        transform: 'rotate(15deg)',
        transformOrigin: 'left',
        right: 22,
      },
    },
    cardsBackContainer: {
      // width: '100%',
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      // bottom not top to avoid conflict with winSign
      bottom: '34%',
      right: 0,
      '&.myCardsBackContainer': {
        bottom: '30%',
      },
      '&.playersRHS': {
        left: 0,
        right: 'unset',
      },
    },
    '@keyframes foldAnimation': {
      '0%': {
        opacity: 1,
        // transform: 'translateY(0)',
      },
      '100%': {
        opacity: 0,
        transform: 'translateY(20px)',
      },
    },
    // TODO @@
    '@keyframes fadeInMove': {
      '0%': {
        opacity: 0,
      },
      '10%': {
        opacity: 1,
      },
      '100%': {
        opacity: 1,
      },
    },
    fadeInMoveAnimation: {
      animation: '$fadeInMove 0.5s ease-in-out forwards',
    },
    foldedCards: {
      height: otherPlayersCardHeight,
      animationName: '$foldAnimation',
      animationDuration: '1s',
      animationFillMode: 'forwards',
    },
    cardBack: {
      position: 'relative',
      height: otherPlayersCardHeight,
      // TODO cubic-bezier
      // display: 'block',
      // transitionTimingFunction: 'cubic-bezier(0.23, 0.81, 0.67, 1.03)',
    },
    cardBack_0: {
      extend: 'cardBack',
      // transform: 'rotate(-12.5deg)',
      '&.omaha': {
        transitionProperty: 'all',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: '1s',
        // transform: 'translateY(3px) rotate(-12.5deg)',
      },
    },
    cardBack_1: {
      extend: 'cardBack',
      // transform: 'rotate(10deg)',
      marginLeft: -10.5,
      '&.omaha': {
        // marginLeft: -27.5,
        transitionProperty: 'all',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: '1.1s',
        // transform: 'rotate(-5deg)',
      },
    },
    cardBack_2: {
      extend: 'cardBack',
      marginLeft: -10,
      '&.omaha': {
        // marginLeft: -27.5,
        transitionProperty: 'all',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: '1.2s',
        // transform: 'rotate(5deg)',
      },
    },
    cardBack_3: {
      extend: 'cardBack',
      marginLeft: -10,
      '&.omaha': {
        // marginLeft: -27.5,
        transitionProperty: 'all',
        transitionTimingFunction: 'ease-in-out',
        transitionDuration: '1.3s',
        // transform: 'translateY(3px) rotate(12.5deg)',
      },
    },
    // TODO
    omahaCardList: {
      right: -22,
      '&$enlargedCardAnimationOmaha': {
        right: -40,
      },
    },
    omahaResultCardList: {
      right: -84,
    },
    playerMoneyAndDecisionContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      background: 'transparent',
      // boxShadow: '0px 3px 6px #0000008C',
      borderRadius: '5px 5px 0px 0px',
      opacity: '0.95',
      textAlign: 'center',
      lineHeight: '14px',
      width: '100%',
      minHeight: 29,
      padding: '1px 0px 0px 0px',
      '&.isWinner': {
        // backgroundColor: '#FFA700',
        boxShadow: '#FFD945 0px 0px 15px',
        zIndex: 1,
      },
    },
    playerBalance: {
      textAlign: 'center',
      height: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    myBalanceButton: {
      cursor: 'default',
      position: 'absolute',
      // higher than NewTimer
      zIndex: 2,
      height: '50%',
      width: '100%',
      '&.ant-btn': {
        background: 'transparent',
        border: 'transparent',
        color: 'transparent',
      },
    },
    whiteDivider: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 60,
      height: 3,
      backgroundRepeat: 'no-repeat',
      margin: 'auto',
      background: "url('/images-mobile/game-room/Player/white-divider.svg')",
      backgroundPosition: 'center',
      // backgroundRepeat: 'no-repeat',
      // backgroundImage: 'radial-gradient(#7b7b7b 0%, #8080804d 50%,transparent 100%)',
    },
    playerName: {
      height: '50%',
      textAlign: 'center',
      letterSpacing: '0px',
      // width: 80,
      color: '#FFFFFF',
      background: 'transparent',
      opacity: 0.9,
      fontSize: '12px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      // margin: '0 2px',
      padding: '0 15px',
    },
    myBestCombination: {
      whiteSpace: 'nowrap',
      width: 'fit-content',
      position: 'fixed',
      bottom: -4,
    },
    myBestCombinationALLin: {
      extend: 'myBestCombination',
      bottom: -44,
    },
    hiddenButOccupySpace: {
      visibility: 'hidden',
      // for myBestCombination
      height: 20,
    },
    playerOrder: {
      color: 'red',
      zIndex: 1,
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      width: iconWidth,
      textAlign: 'center',
      fontSize: 20,
    },
    chips: {
      fontSize: 20,
    },
    // TODO
    inAction: {
      border: '2px solid red',
    },
    displayContainer: {
      // background:'grey',
      color: theme.textColor,
      // border: '2px solid red',
      // position:'relative'
      display: 'flex',
      // todo: for player on the left
      // flex-direction: row-reverse;
      flexDirection: 'column',
      alignItems: 'center',
    },
    playerBottomActionTop: {
      extend: 'displayContainer',
      flexDirection: 'column',
      '& > div:first-child': {
        marginBottom: 0,
      },
      '& $playerAvatarBorder': {
        fontSize: 60,
      },
    },
    playerLeftActionRight: {
      extend: 'displayContainer',
      flexDirection: 'row-reverse',
    },
    playerRightActionLeft: {
      extend: 'displayContainer',
      flexDirection: 'row',
    },
    playerTopActionBottom: {
      extend: 'displayContainer',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& $roleAndChipContainer': {
        // Chip margin
        zIndex: 4,
        marginTop: 30,
      },
    },
    playerAllIn: {
      // extend: 'displayContainer',
      color: theme.textColor,
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& $roleAndChipContainer': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column-reverse',
      },
      '& $dealerBox': {
        position: 'absolute',
        top: 88,
        right: -23,
        zIndex: 1,
      },
    },
    playerTopCenterAllIn: {
      extend: 'playerAllIn',
      color: theme.textColor,
      display: 'flex',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      '& $roleAndChipContainer': {
        position: 'relative',
        top: 24,
      },
      '& $dealerBox': {
        position: 'absolute',
        top: 88,
        right: -23,
        zIndex: 1,
      },
    },
    playerTopLeftAllIn: {
      extend: 'playerAllIn',
      flexDirection: 'row-reverse',
      alignItems: 'flex-end',
      '& $dealerBox': {
        top: 3,
        right: 1,
        zIndex: 1,
      },
    },
    playerTopRightAllIn: {
      extend: 'playerAllIn',
      flexDirection: 'row',
      alignItems: 'flex-end',
      '& $dealerBox': {
        position: 'absolute',
        top: 16,
        right: 80,
        zIndex: 1,
      },
    },
    playerBottomActionTopAllIn: {
      extend: 'displayContainer',
      flexDirection: 'column',
      '& > div:first-child': {
        marginBottom: 0,
      },
      '& $playerAvatarBorder': {
        fontSize: 60,
      },
      '& $dealerBox': {
        position: 'absolute',
        top: 38,
        right: -4,
        zIndex: 1,
      },
    },
    currentDecision: {
      width: 'fit-content',
      position: 'absolute',
      top: '103%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 5,
      textAlign: 'center',
      whiteSpace: 'nowrap',
      fontSize: 10,
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #4AB172;',
      boxShadow:
        'inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
      borderRadius: 52,
      // padding: '3px 10px',
      padding: '3px 15px',
      '&.leftOffset': {
        transform: 'translateX(0%)',
        left: 'unset',
        right: 0,
      },
    },
    persistentFoldLabel: {
      extend: 'currentDecision',
      top: '103%',
      background: ' linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #757575;',
      boxShadow:
        'inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
      '&.isMyself': {
        top: '86.5%',
        width: 'fit-content',
      },
      '&.leftOffset': {
        top: '86.5%',
        width: 'fit-content',
        left: 'unset',
        transform: 'unset',
        right: 0,
      },
    },
    myDecision: {
      width: 'fit-content',
      top: '86.5%',
      left: '50%',
      transform: 'translate(-50%, 0%)',
    },
    yellowBox: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #FFCD3E;',
      boxShadow:
        'inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25)',
    },
    greenBox: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #33DD55;',
      boxShadow:
        'inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25)',
    },
    blueBox: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #00ADFB;',
      boxShadow:
        ' inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
    },
    orangeBox: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #ff9020;',
      boxShadow:
        ' inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
    },
    pinkBox: {
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #f97878;',
      boxShadow:
        ' inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
    },
    greyBox: {
      background: ' linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #757575;',
      boxShadow:
        'inset 0px -4px 4px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 1px 1px rgba(255, 255, 255, 0.25);',
    },
    chipsWrapper: {
      minWidth: chipsWrapperMinWidth,
      minHeight: 32,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    chipsContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      margin: '10px 0',
    },
    chipColumn: {
      display: 'flex',
      flexDirection: 'column-reverse',
      '& img': {
        marginBottom: '-60%',
      },
    },
    chip: {
      height: 12,
      // width: '25px',
    },
    roleAndChipContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      margin: '0 5px',
      width: 40,
      height: 40,
    },
    myCards: {
      position: 'absolute',
      left: '25%',
      bottom: '35%',
      transition: 'opacity 1s ease-in-out',
    },
    dealerBox: {
      width: '20px',
      height: '20px',
      backgroundColor: '#6E6DFE',
      fontSize: 10,
      textAlign: 'center',
      borderRadius: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    decisionAndBetField: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: theme.betTextColor,
      width: '80px',
      height: '32px',
      background: '#3A3839 0% 0% no-repeat padding-box;',
      border: '1px solid #B2B2B2;',
      borderRadius: '19px',
      opacity: '0.79',
      textAlign: 'center',
      '& > div': {
        lineHeight: '105%',
      },
      // border: '2px solid orange',
    },

    timerContainer: {
      position: 'absolute',
      width: '122%',
      height: '122%',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
    timerContainer2: {
      width: '140%',
      height: '90%',
      top: '91%',
      left: '57%',
      zIndex: 1,
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
    },
    winPercentageDisplay: {
      position: 'absolute',
      textAlign: 'center',
    },
    topWinPercentage: {
      extend: 'winPercentageDisplay',
      // left: -90,
      right: -118,
      top: 5,
    },
    topWinPercentageAndResultIsShowing: {
      extend: 'topWinPercentage',
      transform: 'translateY(50%)',
    },
    rightWinPercentage: {
      extend: 'winPercentageDisplay',
      top: 0,
      left: 85,
    },
    leftWinPercentage: {
      extend: 'winPercentageDisplay',
      top: 0,
      right: 85,
    },
    bottomWinPercentage: {
      extend: 'winPercentageDisplay',
      left: 85,
      top: 0,
    },
    advantagous: {
      background: '#246127',
    },
    bubbleIcon: {
      fontSize: 70,
    },
    blueLabel: {
      color: 'white',
      fontWeight: 400,
      fontSize: 12,
      background: 'linear-gradient(180deg, rgba(85, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)',
      border: '1px solid #550000',
      boxShadow: '0px 0px 5px rgba(255, 255, 255, 0.5), 0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '5px',
      width: 78,
      padding: '2px',
      overflow: 'visible',
    },
    greenLabel: {
      extend: 'blueLabel',
      background: 'linear-gradient(180deg, rgba(0, 85, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)',
      border: '1px solid #005500',
      top: '85%',
      width: 'fit-content',
      whiteSpace: 'nowrap',
    },
    disconnectedTimerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 45,
      width: 45,
      borderRadius: '22px',
      background:
        'radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(43,43,43,0.7611111111111111) 23%, rgba(255,255,255,0.3388888888888889) 100%)',
      zIndex: 1,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    hidden: {
      visibility: 'hidden',
    },
    hiddenTimer: {
      // otherwise other players' timers will still be rendering
      display: 'none',
    },
    isTransparent: {
      opacity: 0.5,
    },
    isFolded: {
      filter: 'brightness(0.5)',
    },
    winPercentageContainer: {
      opacity: 0.9,
    },
    winnerSignText: {
      display: 'inline-block',
      fontSize: '20px',
      fontWeight: 450,
      fontFamily: 'PingFang HK',
      position: 'relative',
      '&:before': {
        content: 'attr(data-text)',
        background: 'linear-gradient(to bottom,#261603 0%, #6E4D21 100%)',
        '-webkit-text-stroke': '2px transparent',
        '-webkit-background-clip': 'text',
      },
      '&:after': {
        content: 'attr(data-text)',
        left: 0,
        top: 0,
        position: 'absolute',
        backgroundImage:
          'linear-gradient(106.01deg, #FBE37D 0%, #DABD60 33.33%, #B3892B 66.67%, #DCBB59 100%)',
        ' -webkit-background-clip': 'text',
        color: 'transparent',
        textShadow: '0px 0px 10px #FFD945, 0px 3px 20px #000000',
      },
    },
    winnerSign: {
      margin: 'auto',
      textAlign: 'center',
      // position: 'absolute',
      // zIndex: 6,
      // top: '20%',
    },
    winnerTextImage: {
      margin: 'auto',
      textAlign: 'center',
      position: 'absolute',
      zIndex: 6,
      top: '15%',
      height: 45,
      '&.playerLeftActionRight': {
        left: '50%',
        transform: 'translateX(-50%)',
      },
      '&.playerRightActionLeft': {
        right: '50%',
        transform: 'translateX(50%)',
      },
      '&.isMyself': {
        height: 50,
        top: '20%',
      },
    },
    outcardsOnTable: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      position: 'relative',
      left: '50%',
      transform: 'translate(-50%, 0)',
      textAlign: 'initial',
      // zIndex: ACTION_BUTTON_Z_INDEX.COMMUNITY_CARD,
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.25)',
        filter: 'brightness(1.5)',
      },
      '100%': {
        transform: 'scale(1)',
      },
    },
    '@keyframes darken': {
      '0%': {
        transform: 'scale(1)',
        filter: 'brightness(0.5)',
      },
      '50%': {
        transform: 'scale(1.2)',
        filter: 'brightness(0.5)',
      },
      '100%': {
        transform: 'scale(1)',
        filter: 'brightness(0.5)',
      },
    },
    sendEmojiButton: {
      animation: '$pulse 1s infinite',
      position: 'absolute',
      top: -4,
      left: -7,
      zIndex: ACTION_BUTTON_Z_INDEX.SEND_EMOJI_BUTTON,
      background: '#200049',
      border: 'none',
      colo: 'white',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      // '&.ant-btn-icon-only': {
      //   width: 20,
      //   height: 20,
      // },
      '&.ant-btn-sm': {
        minWidth: 23,
        height: 23,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '&.ant-btn[disabled]': {
        background: '#200049',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        filter: 'brightness(0.4)',
      },
      '&:hover, &:active, &:focus': {
        background: '#200049',
        filter: 'brightness(0.8)',
      },
      '&.darken': {
        animation: '$darken 1s infinite',
      },
    },
    sendEmojiLabel: {
      width: 12,
      height: 12,
    },
    sendEmojiIcon: {
      color: 'white',
    },
    combinationContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      width: 'fit-content',
      justifyContent: 'flex-end',
      height: '30px',
    },
    bestCombinationBody: {
      height: '30px',
      backgroundSize: '100% 20px',
      backgroundPosition: 'bottom',
      background: 'transparent url(/images-mobile/game-room/bestCombinationBody.webp) no-repeat',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: ' flex-end',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginRight: '-1.5px',
      // paddingLeft: '10px',
    },
    combinationContainerLeft: {
      background: 'transparent url(/images-mobile/game-room/bestCombinationBody.webp) no-repeat',
      width: '100%',
      height: '20px',
      backgroundSize: '100% 100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: ' flex-end',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginRight: '-1px',
      paddingLeft: '10px',
    },
    combinationText: {
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: '14px',
      lineHeight: '30px',
      transform: 'translateX(3px)',
    },
    gradientText: {
      background:
        'linear-gradient(106.01deg, #FBE37D 0%, #DABD60 33.33%, #B3892B 66.67%, #DCBB59 100%)',
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      backgroundClip: 'text',
      textFillColor: 'transparent',
    },
    greyGradient: {
      extend: 'gradientText',
      background:
        'linear-gradient(106.01deg, #E7E7E7 0%, #BEBEBE 33.33%, #9E9E9E 66.67%, #EBEBEB 100%)',
    },
    blueGradient: {
      extend: 'gradientText',
      background:
        'linear-gradient(106.01deg, #ADBAFF 0%, #7F98D8 33.33%, #4969BB 66.67%, #8EA0CE 100%)',
    },
    goldGradientWithShadow: {
      extend: 'gradientText',
      background:
        'linear-gradient(106.01deg, #ADBAFF 0%, #7F98D8 33.33%, #4969BB 66.67%, #8EA0CE 100%)',
      textShadow: '0px 0px 10px rgb(251 227 125 / 70%)',
    },
    bestCombinationTriangle: {
      background:
        'transparent url(/images-mobile/game-room/bestCombinationTriangle.webp) no-repeat',
      height: '30px',
      width: '29px',
      backgroundSize: '100% 20px',
      backgroundPosition: 'bottom',
    },
    currentDecisionAllin: {
      fontSize: 12,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
